import {useSelector,useDispatch} from 'react-redux'
import {
	updateClientProfileData,
	selectUserById,
	getClient,
	getAllTrainers,
	getAllClients,
	selectAllTrainers,
	selectClientsById,
	selectAllClients,
	deleteClient
} from './usersSlice'

import {useHistory} from 'react-router-dom'

import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'

export const useUser = user_id_number => {
	const dispatch = useDispatch()

	const currentUser = useSelector(state=>state.users.current_user)

	const client = useSelector(state=>
		currentUser.account_type==="client" ? currentUser : 
		selectUserById(state,user_id_number))
	
	if (!client) {
		dispatch(getClient(user_id_number))
	}

	return client
}

export const useClient = client_id => {
	const dispatch = useDispatch()
	const user = useSelector(state=>state.users.current_user)
	const client = useSelector(state=>(
		user.account_type === 'client' ?
		user :
		selectClientsById(state,client_id
	)))
	const isPending = useSelector(state=>Boolean(state.users.pending[client_id]))
	if(!client&&!isPending){
		dispatch(getClient(client_id))
	}
	return client
}

export const useGymTrainers = ()=>{
	const dispatch = useDispatch()
	const trainers = useSelector(selectAllTrainers)
	const entities = useSelector(state=>state.users.trainers.entities)
	const status = useSelector(state=>state.users.trainers.status)
	if(status === 'init'){
		dispatch(getAllTrainers())
	}
	return {status,trainers,entities}
}

export const useClients = (opts={})=>{
	const dispatch = useDispatch()
	const clients = useSelector(selectAllClients)
	const entities = useSelector(state=>state.users.clients.entities)
	const status = useSelector(state=>state.users.clients.status)
	if (status === 'init') {
		dispatch(getAllClients(opts))
	}
	return {status,clients,entities}
}

export const useUpdateClientProfileData = ()=>{
	const statusDispatch = useApiStatusDispatch()

	//this is an older api call so legacy logic is hidden here
	//this maps fields on the standardized update object to the
	//legacy fields expected by the api

	const legacyFieldsMap = {
		password:'new_password',
		user_email:'new_email',
		user_name:'new_user_name',
		user_id:'new_user_id',
		phone:'new_phone',
		birthdate:'new_dob',
		goals:'new_goals',
		likes:'new_likes',
		dislikes:'new_dislikes',
		injuries:'new_injuries',
		height:'new_height',
		height_units:'new_height_units',
		weight:'new_weight',
		weight_units:'new_weight_units',
		clubready_barcode:'clubready_barcode',
		clubready_id:'clubready_id',
		measurement_system:'new_measurement_system',
		sex_id:'new_sex_id',
		par_q:'new_par_q',
		contract:'new_contract',
		profile_pic:'new_profile_pic_url',
		setup_account:'setup_account',
		inactivate_account:'inactivate_account',
		user_trainer_id:'trainer_id',
		test:'test'
	}

	const update = (clientId,update)=>{
		//create a payload that matches the signature of a standardized 
		//api payload but has all the necessary legacy fields. This way
		//this hook looks like a standard API integration to all components
		//using it and the Redux reducers but sends the right data to the
		//legacy api call 
		const payload = {
			client_id:clientId,
			id:clientId,
			using_s3:1,
			update
		}
		Object.keys(update).forEach((standardField)=>{
			const legacyField = legacyFieldsMap[standardField]
			payload[legacyField] = update[standardField]
		})
		
		return statusDispatch(updateClientProfileData(payload),'client','edit')
	}

	return update
}

export const useRemoveClient = ()=>{
	const history = useHistory()
	const statusDispatch = useApiStatusDispatch()
	const remove = (id,cb)=>{
		if(window.confirm('Are you sure you would like to delete this client and all their data?')){
			return statusDispatch(deleteClient(id),"client","delete").then(()=>{
				if(cb) cb()
				history.goBack()
			})
		} 
	}
	return remove
}